import { ContentTypes } from '@invoice-simple/common';

import environmentStore from 'src/stores/EnvironmentStore';
import { getIsPaymentsToken } from './isPaymentsToken';

async function getHeaders() {
  const headers: Record<string, string> = {
    'Content-Type': ContentTypes.APP_JSON,
    'x-is-platform': 'web',
    'x-is-version': environmentStore.getReactAppVersion()
  };

  headers.Authorization = `Bearer ${await getIsPaymentsToken()}`;
  return headers;
}

export async function invokeIsPayments<T = unknown, U = unknown>(
  method: 'POST' | 'GET' | 'PUT' | 'PATCH',
  endpoint: string,
  body?: U
): Promise<T> {
  const url = `${process.env.REACT_APP_IS_PAYMENTS}${endpoint}`;
  const headers = await getHeaders();
  try {
    const res = await fetch(url, { method, headers, body: JSON.stringify(body) });
    if (res.status >= 400) {
      throw new Error(res.statusText);
    }
    return res.json();
  } catch (error) {
    throw new Error(`Unexpected error calling api ${method} ${url}: ${error.message}`);
  }
}
